import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { formatDate } from './format-date';
import { bodySx } from './styles';

interface LegalDocumentLayoutProps {
  title: ReactNode;
  updatedAt: string | null;
  children: ReactNode;
  footer?: ReactNode;
}

export const LegalDocumentLayout = ({
  title,
  updatedAt,
  children,
  footer,
}: LegalDocumentLayoutProps) => (
  <Box component="article" sx={{ maxWidth: 720, mx: 'auto', px: 3, py: 5 }}>
    {title}
    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 4 }}>
      {updatedAt ? `Last updated ${formatDate(updatedAt)}` : 'Not saved yet'}
    </Typography>
    <Box sx={bodySx}>{children}</Box>
    {footer}
  </Box>
);
